import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { AutoCompleteStoreName } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/AutoCompleteStoreName";
import { StateOrProvince } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/StateOrProvince";
import { useFormValidation } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/useFormValidation";
import { COUNTRY } from "@faire/web--source/common/consts/COUNTRY";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import Checkbox from "@faire/web--source/slate/Checkbox/index";
import { Dropdown } from "@faire/web--source/slate/Dropdown";
import { Input } from "@faire/web--source/slate/Input";
import { PhoneInput } from "@faire/web--source/slate/Input/PhoneInput";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { getAddressSchema } from "@faire/web--source/ui/Addresses/addressSchema";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Form, Formik } from "formik";
import React from "react";
import styled from "styled-components";
export var ShippingDetails = function(param) {
    var initialValues = param.initialValues, setFormValues = param.setFormValues, onSubmit = param.onSubmit, apiCallFailed = param.apiCallFailed, apiCallIsLoading = param.apiCallIsLoading, apiCallError = param.apiCallError;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var validateForm = useFormValidation().validateForm;
    var localizedErrorMessage = useLocalizedErrorMessage(apiCallError);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "UDGtla",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add your shipping details"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Formik, {
                initialValues: initialValues,
                onSubmit: onSubmit,
                validate: validateForm,
                children: function(param) {
                    var values = param.values, handleChange = param.handleChange, setFieldValue = param.setFieldValue, errors = param.errors, touched = param.touched, isSubmitting = param.isSubmitting;
                    var addressSchema = getAddressSchema(values.country, strictLocalize);
                    var _addressSchema_labels_address1, _addressSchema_labels_address2, _addressSchema_labels_city, _addressSchema_labels_state, _addressSchema_labels_postal_code;
                    return /*#__PURE__*/ _jsxs(StyledForm, {
                        children: [
                            /*#__PURE__*/ _jsx(Input, {
                                autoFocus: true,
                                label: strictLocalize({
                                    id: "6cJf8F",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "First Name"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "firstName",
                                error: touched.firstName && errors.firstName,
                                value: values.firstName,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                label: strictLocalize({
                                    id: "l3bCPd",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Last Name"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "lastName",
                                error: touched.lastName && errors.lastName,
                                value: values.lastName,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(Dropdown, {
                                label: strictLocalize({
                                    id: "f4QyHh",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Country"
                                        }
                                    ]
                                }),
                                options: COUNTRY(strictLocalize),
                                onSelect: function(country) {
                                    setFieldValue("country", country.value);
                                    setFormValues(_object_spread_props(_object_spread({}, values), {
                                        country: country.value
                                    }));
                                },
                                value: values.country
                            }),
                            /*#__PURE__*/ _jsx(AutoCompleteStoreName, {
                                formValues: values,
                                setFieldValue: setFieldValue,
                                setFormValues: setFormValues,
                                error: touched.storeName && errors.storeName
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                label: (_addressSchema_labels_address1 = addressSchema.labels["address1"]) !== null && _addressSchema_labels_address1 !== void 0 ? _addressSchema_labels_address1 : strictLocalize({
                                    id: "Nh4jVr",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Street"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "address1",
                                error: touched.address1 && errors.address1,
                                value: values.address1,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                label: (_addressSchema_labels_address2 = addressSchema.labels["address2"]) !== null && _addressSchema_labels_address2 !== void 0 ? _addressSchema_labels_address2 : strictLocalize({
                                    id: "roN+4a",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Apt, Suite (optional)"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "address2",
                                error: touched.address2 && errors.address2,
                                value: values.address2,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                label: (_addressSchema_labels_city = addressSchema.labels["city"]) !== null && _addressSchema_labels_city !== void 0 ? _addressSchema_labels_city : strictLocalize({
                                    id: "4pJ83R",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "City"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "city",
                                error: touched.city && errors.city,
                                value: values.city,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(StateOrProvince, {
                                shouldRender: addressSchema.required_fields.includes("state"),
                                label: (_addressSchema_labels_state = addressSchema.labels["state"]) !== null && _addressSchema_labels_state !== void 0 ? _addressSchema_labels_state : strictLocalize({
                                    id: "kw+EhF",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "State"
                                        }
                                    ]
                                }),
                                country: values.country,
                                error: touched.state && errors.state,
                                value: values.state,
                                handleChange: handleChange,
                                setFieldValue: setFieldValue,
                                setFormValues: setFormValues,
                                formValues: values
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                label: (_addressSchema_labels_postal_code = addressSchema.labels["postal_code"]) !== null && _addressSchema_labels_postal_code !== void 0 ? _addressSchema_labels_postal_code : strictLocalize({
                                    id: "50mbi6",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Zipcode"
                                        }
                                    ]
                                }),
                                type: "text",
                                name: "zipcode",
                                error: touched.zipcode && errors.zipcode,
                                value: values.zipcode,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(PhoneInput, {
                                "aria-label": strictLocalize({
                                    id: "NA/djP",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Phone Number"
                                        }
                                    ]
                                }),
                                label: strictLocalize({
                                    id: "NA/djP",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Phone Number"
                                        }
                                    ]
                                }),
                                name: "phoneNumber",
                                value: values.phoneNumber,
                                defaultPhoneNumber: values.phoneNumber,
                                defaultCountry: values.country,
                                onChangePhoneNumber: function(inputValue) {
                                    setFieldValue("phoneNumber", inputValue);
                                    setFormValues(_object_spread_props(_object_spread({}, values), {
                                        phoneNumber: inputValue
                                    }));
                                },
                                error: touched.phoneNumber && errors.phoneNumber,
                                placeholder: strictLocalize({
                                    id: "NA/djP",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Phone Number"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Checkbox, {
                                label: strictLocalize({
                                    id: "3Hiwox",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Sign up to get email notifications"
                                        }
                                    ]
                                }),
                                "aria-label": strictLocalize({
                                    id: "3Hiwox",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Sign up to get email notifications"
                                        }
                                    ]
                                }),
                                checked: values.optIntoEmailNotifications,
                                onChange: function(e) {
                                    setFieldValue("optIntoEmailNotifications", e.target.checked);
                                    setFormValues(_object_spread_props(_object_spread({}, values), {
                                        optIntoEmailNotifications: e.target.checked
                                    }));
                                }
                            }),
                            /*#__PURE__*/ _jsx(StyledButton, {
                                type: "submit",
                                disabled: isSubmitting || apiCallIsLoading,
                                loading: isSubmitting || apiCallIsLoading,
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "1VjXv3",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Submit"
                                        }
                                    ]
                                })
                            }),
                            apiCallFailed && !apiCallIsLoading && !isSubmitting ? /*#__PURE__*/ _jsx(Typography, {
                                color: Core.text.critical,
                                children: localizedErrorMessage
                            }) : null
                        ]
                    });
                }
            })
        ]
    });
};
var useLocalizedErrorMessage = function(error) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (!error || !error.message) {
        return null;
    }
    if (error.message === "Business name is required.") {
        return strictLocalize({
            id: "23qgb9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Business name is required."
                }
            ]
        });
    }
    return strictLocalize({
        id: "qJl918",
        defaultMessage: [
            {
                type: 0,
                value: "Please check your information and try again."
            }
        ]
    });
};
var Container = styled(Column).attrs({
    gap: "4x"
}).withConfig({
    componentId: "sc-60ea3647-0"
})([
    "width:100%;"
]);
var StyledForm = styled(Form).withConfig({
    componentId: "sc-60ea3647-1"
})([
    "width:100%;display:flex;flex-direction:column;gap:",
    ";"
], getSpacing("3x"));
var StyledButton = styled(Button).withConfig({
    componentId: "sc-60ea3647-2"
})([
    "width:100%;"
]);
